import { ArticleHeading1 } from '@cian/ui-kit';

import { FC } from 'react';

import { ITitleProps } from './types';

export const Title: FC<ITitleProps> = props => {
  const { coworkingName, className } = props;

  return (
    <div className={className}>
      <ArticleHeading1>{coworkingName}</ArticleHeading1>
    </div>
  );
};

Title.displayName = 'Title';
